const { generate: genId } = require("shortid");
const {
	assignIdsToHeaders,
	transformDocumentGroup,
} = require("../../utils/prismic-data-utils");

module.exports.transformDemographicPageData = data =>
	data.prismic.allReapredistDemographicsPages.edges.map(({ node }) => ({
		mainBodyText: assignIdsToHeaders(node.mainBodyText),
		storymapUrl: node.storymapLink.url,
		storymapLinkHeader: node.storymapLinkHeader[0].text,
		documentGroups: node.body ? node.body.map(transformDocumentGroup) : [],
		additionalInformationHeader: assignIdsToHeaders(
			node.additionalInformationHeader
		),
		additionalInformationLinks: node.additionalInformationLinks.map(
			link => ({
				...link,
				id: genId(),
				url: link.url ? link.url.url : null,
			})
		),
	}))[0];
